module.exports = {"pathContext":{"slug":"/es/products-services/","langKey":"es"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/es-products-services.json
// module id = 1230
// module chunks = 196944793530482